module.exports = __webpack_public_path__ + "static/media/16.85e5db3d.jpeg";